import { senderAvatarColor, senderInitials } from "@/lib/senderAvatar";
import { cn } from "@/lib/cn";

type Props = {
  label: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const SIZE_CLASS = {
  sm: "h-8 w-8 text-[11px]",
  md: "h-10 w-10 text-xs",
  lg: "h-12 w-12 text-sm",
} as const;

export function SenderAvatar({ label, size = "md", className }: Props) {
  const initials = senderInitials(label);
  const color = senderAvatarColor(label);

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white shadow-sm",
        SIZE_CLASS[size],
        className
      )}
      style={{ backgroundColor: color }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
